let pendingRefresh = null;

function scheduleOneRefresh(targetEl) {
  // Prevent multiple refreshes in the same tick
  if (pendingRefresh) return;
  pendingRefresh = targetEl;

  requestAnimationFrame(() => {
    pendingRefresh.dispatchEvent(new Event('change', { bubbles: true }));
    pendingRefresh = null;
  });
}

function getCheckedMin(root) {
  const checkedVals = Array.from(root.querySelectorAll('[data-rating-checkbox]:checked'))
    .map((cb) => Number(cb.getAttribute('data-rating-val')))
    .filter(Number.isFinite)
    .sort((a, b) => a - b);

  return checkedVals.length ? checkedVals[0] : null;
}

function setBucketsFromMin(root, min) {
  const boxes = root.querySelectorAll('[data-rating-checkbox]');
  boxes.forEach((cb) => {
    const val = Number(cb.getAttribute('data-rating-val'));
    cb.checked = (min == null) ? false : (Number.isFinite(val) && val >= min);
  });

  // Trigger ONE Shopify/Dwell facets refresh (debounced)
  const first = root.querySelector('[data-rating-checkbox]');
  if (first) scheduleOneRefresh(first);
}

function clearBuckets(root) {
  const boxes = root.querySelectorAll('[data-rating-checkbox]');
  boxes.forEach((cb) => (cb.checked = false));

  const first = root.querySelector('[data-rating-checkbox]');
  if (first) scheduleOneRefresh(first);
}

function updatePressedStates(root) {
  const min = getCheckedMin(root);

  root.querySelectorAll('.rating-star-btn').forEach((btn) => {
    const btnMin = Number(btn.dataset.min);
    const pressed = (min != null && Number.isFinite(btnMin) && btnMin === min);
    btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    btn.classList.toggle('is-active', pressed);
  });
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.rating-star-btn');
  if (btn) {
    const root = btn.closest('[data-rating-stars-filter]');
    if (!root) return;

    const clickedMin = Number(btn.dataset.min);
    const currentMin = getCheckedMin(root);

    // Toggle: clicking the already-active min clears the rating filter
    if (Number.isFinite(clickedMin) && currentMin === clickedMin) {
      clearBuckets(root);
    } else {
      setBucketsFromMin(root, clickedMin);
    }

    updatePressedStates(root);
    return;
  }

  const clear = e.target.closest('[data-clear-rating]');
  if (clear) {
    const root = clear.closest('[data-rating-stars-filter]');
    if (!root) return;

    clearBuckets(root);
    updatePressedStates(root);
  }
});

// Keep UI state correct after AJAX facet updates
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-rating-stars-filter]').forEach(updatePressedStates);
});
document.addEventListener('facets:updated', () => {
  document.querySelectorAll('[data-rating-stars-filter]').forEach(updatePressedStates);
});
